const getSign = (value: string): [boolean, string] => {
    if (value[0] === '-') {
        return [false, value.substr(1)];
    }

    return [true, value];
};

const reverseOneDigit = (value: string): string => {
    switch (value) {
    case '0': return '9';
    case '1': return '8';
    case '2': return '7';
    case '3': return '6';
    case '4': return '5';
    case '5': return '4';
    case '6': return '3';
    case '7': return '2';
    case '8': return '1';
    case '9': return '0';
    }

    throw Error('single digit expected');
};

const reverseDigits = (value: string): string => {
    const result = [];

    for (const char of value.split('')) {
        result.push(reverseOneDigit(char));
    }

    return result.join('');
};

export const formatPriceForSorting = (leftZeroes: number, rightZeroes: number, value: string): string => {
    const [isPositiveNumber, rest] = getSign(value);

    const chunks = rest.split('.');
    const [integer, fractional, ...rest2] = chunks;

    if (rest2.length !== 0) {
        throw Error('Incorrect currency format 1');
    }

    if (integer === undefined) {
        throw Error('Incorrect currency format 2');
    }

    const integerPad = integer.padStart(leftZeroes, '0');
    const fractionalPad = (fractional ?? '').padEnd(rightZeroes, '0');

    if (isPositiveNumber) {
        return [
            '1',
            '_',
            integerPad,
            '.',
            fractionalPad
        ].join('');
    } else {
        return [
            '0',
            '_',
            reverseDigits(integerPad),
            '.',
            reverseDigits(fractionalPad)
        ].join('');
    }
};

